// Vendor libraries
import { ChangeDetectorRef, ElementRef, EventEmitter, } from '@angular/core';
// Services
import { DropdownHelperService } from 'NewAngular/services/dropdown-helper.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/dropdown-helper.service";
import * as i2 from "@angular/common";
import * as i3 from "../../../directives/disabled/disabled.directive";
import * as i4 from "../../../directives/icon/icon.directive";
import * as i5 from "@angular/forms";
import * as i6 from "../../modals/help-modal/components/help-modal.component";
const _c0 = ["ycnCascadingDropdown"];
const _c1 = a0 => ({ "dropdown-toggle": a0 });
const _c2 = a0 => ({ show: a0 });
const _c3 = a0 => ({ "disabled": a0 });
const _forTrack0 = ($index, $item) => $item.value;
function CascadingDropdownComponent__svg_svg_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 7);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", ctx_r1.config.title.icon);
} }
function CascadingDropdownComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 8);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("textContent", ctx_r1.config.title.icon ? "\u00A0" + ctx_r1.config.title.label : ctx_r1.config.title.label);
} }
function CascadingDropdownComponent_ng_container_6_span_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 14);
} }
function CascadingDropdownComponent_ng_container_6_span_1_div_2_a_2__svg_svg_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 7);
} if (rf & 2) {
    const listItem_r4 = i0.ɵɵnextContext(4).$implicit;
    i0.ɵɵproperty("name", listItem_r4.icon);
} }
function CascadingDropdownComponent_ng_container_6_span_1_div_2_a_2_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 17);
    i0.ɵɵlistener("click", function CascadingDropdownComponent_ng_container_6_span_1_div_2_a_2_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r3); const listItem_r4 = i0.ɵɵnextContext(3).$implicit; const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.submit(listItem_r4)); });
    i0.ɵɵtemplate(1, CascadingDropdownComponent_ng_container_6_span_1_div_2_a_2__svg_svg_1_Template, 1, 1, "svg", 3);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵelement(3, "span", 18)(4, "div");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const listItem_r4 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵproperty("disabled", listItem_r4.disabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !!listItem_r4.icon);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", listItem_r4.label);
} }
function CascadingDropdownComponent_ng_container_6_span_1_div_2_div_3__svg_svg_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 7);
} if (rf & 2) {
    const listItem_r4 = i0.ɵɵnextContext(4).$implicit;
    i0.ɵɵproperty("name", listItem_r4.icon);
} }
function CascadingDropdownComponent_ng_container_6_span_1_div_2_div_3_For_7_Case_0_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 22)(1, "input", 25);
    i0.ɵɵlistener("change", function CascadingDropdownComponent_ng_container_6_span_1_div_2_div_3_For_7_Case_0_Template_input_change_1_listener() { i0.ɵɵrestoreView(_r5); const sublistItem_r6 = i0.ɵɵnextContext().$implicit; const listItem_r4 = i0.ɵɵnextContext(4).$implicit; const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.handleChange(sublistItem_r6.value, listItem_r4.sublist)); });
    i0.ɵɵtwoWayListener("ngModelChange", function CascadingDropdownComponent_ng_container_6_span_1_div_2_div_3_For_7_Case_0_Template_input_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r5); const sublistItem_r6 = i0.ɵɵnextContext().$implicit; i0.ɵɵtwoWayBindingSet(sublistItem_r6.selected, $event) || (sublistItem_r6.selected = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "span", 26)(3, "span", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const sublistItem_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c3, sublistItem_r6.disabled));
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", !!sublistItem_r6.disabled);
    i0.ɵɵtwoWayProperty("ngModel", sublistItem_r6.selected);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", sublistItem_r6.label, i0.ɵɵsanitizeHtml);
} }
function CascadingDropdownComponent_ng_container_6_span_1_div_2_div_3_For_7_Case_1_Conditional_5_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "\u00A0");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "span", 30);
    i0.ɵɵlistener("click", function CascadingDropdownComponent_ng_container_6_span_1_div_2_div_3_For_7_Case_1_Conditional_5_Template_span_click_2_listener($event) { i0.ɵɵrestoreView(_r8); const sublistItem_r6 = i0.ɵɵnextContext(2).$implicit; i0.ɵɵnextContext(5); const helpModal_r9 = i0.ɵɵreference(8); helpModal_r9.openModal(sublistItem_r6.helpName); return i0.ɵɵresetView($event.stopPropagation()); });
    i0.ɵɵtext(3, "(?)");
    i0.ɵɵelementEnd();
} }
function CascadingDropdownComponent_ng_container_6_span_1_div_2_div_3_For_7_Case_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 23)(1, "input", 28);
    i0.ɵɵlistener("change", function CascadingDropdownComponent_ng_container_6_span_1_div_2_div_3_For_7_Case_1_Template_input_change_1_listener() { i0.ɵɵrestoreView(_r7); const sublistItem_r6 = i0.ɵɵnextContext().$implicit; const listItem_r4 = i0.ɵɵnextContext(4).$implicit; const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.handleChange(sublistItem_r6.value, listItem_r4.sublist)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "span", 26);
    i0.ɵɵelementStart(3, "span", 29);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(5, CascadingDropdownComponent_ng_container_6_span_1_div_2_div_3_For_7_Case_1_Conditional_5_Template, 4, 0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const sublistItem_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", !!sublistItem_r6.disabled)("name", "radioGroup1")("value", sublistItem_r6.value)("checked", sublistItem_r6.selected);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(sublistItem_r6.label);
    i0.ɵɵadvance();
    i0.ɵɵconditional(sublistItem_r6.helpName ? 5 : -1);
} }
function CascadingDropdownComponent_ng_container_6_span_1_div_2_div_3_For_7_Case_2__svg_svg_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 7);
} if (rf & 2) {
    const sublistItem_r6 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("name", sublistItem_r6.icon);
} }
function CascadingDropdownComponent_ng_container_6_span_1_div_2_div_3_For_7_Case_2_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 31);
    i0.ɵɵlistener("click", function CascadingDropdownComponent_ng_container_6_span_1_div_2_div_3_For_7_Case_2_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r10); const sublistItem_r6 = i0.ɵɵnextContext().$implicit; const ctx_r1 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r1.submit(sublistItem_r6)); });
    i0.ɵɵtemplate(1, CascadingDropdownComponent_ng_container_6_span_1_div_2_div_3_For_7_Case_2__svg_svg_1_Template, 1, 1, "svg", 3);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵelement(3, "span", 18);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const sublistItem_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("disabled", sublistItem_r6.disabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !!sublistItem_r6.icon);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", sublistItem_r6.label);
} }
function CascadingDropdownComponent_ng_container_6_span_1_div_2_div_3_For_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵconditionalCreate(0, CascadingDropdownComponent_ng_container_6_span_1_div_2_div_3_For_7_Case_0_Template, 4, 6, "label", 22)(1, CascadingDropdownComponent_ng_container_6_span_1_div_2_div_3_For_7_Case_1_Template, 6, 6, "label", 23)(2, CascadingDropdownComponent_ng_container_6_span_1_div_2_div_3_For_7_Case_2_Template, 4, 3, "a", 24);
} if (rf & 2) {
    let tmp_18_0;
    const listItem_r4 = i0.ɵɵnextContext(4).$implicit;
    i0.ɵɵconditional((tmp_18_0 = listItem_r4.subListType) === "checkbox" ? 0 : tmp_18_0 === "radio" ? 1 : 2);
} }
function CascadingDropdownComponent_ng_container_6_span_1_div_2_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19)(1, "div", 20);
    i0.ɵɵtemplate(2, CascadingDropdownComponent_ng_container_6_span_1_div_2_div_3__svg_svg_2_Template, 1, 1, "svg", 3);
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵelement(4, "span", 18);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 21);
    i0.ɵɵrepeaterCreate(6, CascadingDropdownComponent_ng_container_6_span_1_div_2_div_3_For_7_Template, 3, 1, null, null, _forTrack0);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const listItem_r4 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c2, !!listItem_r4.open))("disabled", listItem_r4.disabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c3, listItem_r4.disabled));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !!listItem_r4.icon);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", listItem_r4.label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c2, !!listItem_r4.open));
    i0.ɵɵadvance();
    i0.ɵɵrepeater(listItem_r4.sublist);
} }
function CascadingDropdownComponent_ng_container_6_span_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 10);
    i0.ɵɵtemplate(2, CascadingDropdownComponent_ng_container_6_span_1_div_2_a_2_Template, 5, 3, "a", 15)(3, CascadingDropdownComponent_ng_container_6_span_1_div_2_div_3_Template, 8, 12, "div", 16);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const listItem_r4 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitch", !!listItem_r4.sublist);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", false);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", true);
} }
function CascadingDropdownComponent_ng_container_6_span_1_a_3_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 32);
    i0.ɵɵlistener("click", function CascadingDropdownComponent_ng_container_6_span_1_a_3_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r11); const listItem_r4 = i0.ɵɵnextContext(2).$implicit; const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.submit(listItem_r4)); });
    i0.ɵɵelement(1, "input", 33)(2, "span", 26);
    i0.ɵɵelementStart(3, "span", 29);
    i0.ɵɵelement(4, "span", 8);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const listItem_r4 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("disabled", listItem_r4.disabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("checked", listItem_r4.selected);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("textContent", listItem_r4.label);
} }
function CascadingDropdownComponent_ng_container_6_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵtemplate(1, CascadingDropdownComponent_ng_container_6_span_1_div_1_Template, 1, 0, "div", 11)(2, CascadingDropdownComponent_ng_container_6_span_1_div_2_Template, 4, 3, "div", 12)(3, CascadingDropdownComponent_ng_container_6_span_1_a_3_Template, 5, 3, "a", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const listItem_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngSwitch", listItem_r4.type);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "divider");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "option");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "checkbox");
} }
function CascadingDropdownComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CascadingDropdownComponent_ng_container_6_span_1_Template, 4, 4, "span", 9);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const listItem_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !listItem_r4.hidden);
} }
/**
 *
 * Cascading Dropdown Component
 *
 * This component is responsible for displaying a scrollable list of items which may be visually grouped. Clicking an
 * item selects it and closes the dropdown. Hovering over an item with a sublist opens the cascading sublist
 * dropdown. Clicking on a sublist item selects the item and places a checkmark next to the item indicating it was
 * selected.
 *
 *
 * Input Properties:
 *   buttonClass: The CSS class to be applied to the button that opens the dropdown
 *   config: The config object, specifying how the dropdown title and items should be configured.
 *   dropdownClass: The CSS class to be applied to the dropdown menu itself
 *   inputDisabled: Whether the dropdown should be disabled
 *   showDropdownCaret: Whether the dropdown caret/arrow should be visible. Set this to false when you want to
 *                      use a different icon as the dropdown toggle.
 *
 *
 * Output properties:
 *  handler: EventEmitter that emits the item's value whenever a new item is selected
 *
 */
export class CascadingDropdownComponent {
    constructor(changeDetector, dropdownHelperService) {
        this.changeDetector = changeDetector;
        this.dropdownHelperService = dropdownHelperService;
        this.inputDisabled = false;
        this.showDropdownCaret = true;
        this.handler = new EventEmitter();
        this.isOpen = false;
    }
    ngAfterViewInit() {
        const autoCloseHandler = () => {
            if (this.isOpen) {
                this.isOpen = false;
            }
            this.changeDetector.markForCheck();
        };
        this.dropdownHelperService.setCloseHandler(this.el.nativeElement.parentElement, autoCloseHandler);
    }
    handleChange(value, sublist = []) {
        // There appears to be a small bug with ngModel + checkbox. Workaround by manually detecting changes for now
        // https://github.com/angular/angular/issues/9275
        this.changeDetector.detectChanges();
        this.selectItem(value, sublist);
        this.handler.emit(value);
        this.isOpen = false;
    }
    toggleOpen() {
        if (!this.inputDisabled || this.isOpen) {
            this.isOpen = !this.isOpen;
        }
    }
    submit(item) {
        if (!item.disabled && item.value) {
            this.handler.emit(item.value);
        }
        this.isOpen = false;
    }
    selectItem(selectedValue, sublist) {
        // Go through and deselect/select the correct items.
        for (let i = 0; i < sublist.length; i += 1) {
            const sublistItem = sublist[i];
            if (sublistItem.value === selectedValue) {
                sublistItem.selected = true;
            }
            else {
                sublistItem.selected = false;
            }
        }
    }
}
CascadingDropdownComponent.ɵfac = function CascadingDropdownComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CascadingDropdownComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.DropdownHelperService)); };
CascadingDropdownComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CascadingDropdownComponent, selectors: [["ycn-cascading-dropdown"]], viewQuery: function CascadingDropdownComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.el = _t.first);
    } }, inputs: { buttonClass: "buttonClass", config: "config", dropdownClass: "dropdownClass", inputDisabled: "inputDisabled", showDropdownCaret: "showDropdownCaret" }, outputs: { handler: "handler" }, standalone: false, decls: 9, vars: 15, consts: [["ycnCascadingDropdown", ""], ["helpModal", ""], ["ycnDisabled", "", 3, "click", "ngClass", "disabled"], ["ycnIcon", "", 3, "name", 4, "ngIf"], [3, "textContent", 4, "ngIf"], [3, "ngClass"], [4, "ngFor", "ngForOf"], ["ycnIcon", "", 3, "name"], [3, "textContent"], [3, "ngSwitch", 4, "ngIf"], [3, "ngSwitch"], ["class", "dropdown-divider", 4, "ngSwitchCase"], [4, "ngSwitchCase"], ["class", "dropdown-item custom-control custom-checkbox custom-checkbox-accented", "href", "javascript:void(0)", "ycnDisabled", "", 3, "disabled", "click", 4, "ngSwitchCase"], [1, "dropdown-divider"], ["class", "dropdown-item", "href", "javascript:void(0)", "ycnDisabled", "", 3, "disabled", "click", 4, "ngSwitchCase"], ["class", "dropdown-nested dropdown", "ycnDisabled", "", 3, "ngClass", "disabled", 4, "ngSwitchCase"], ["href", "javascript:void(0)", "ycnDisabled", "", 1, "dropdown-item", 3, "click", "disabled"], [1, "dropdown-item-text", 3, "textContent"], ["ycnDisabled", "", 1, "dropdown-nested", "dropdown", 3, "ngClass", "disabled"], [1, "dropdown-item", "dropdown-toggle", 3, "ngClass"], [1, "dropdown-menu", "dropdown-menu-right", 3, "ngClass"], [1, "custom-control", "custom-checkbox", "dropdown-item", "custom-checkbox-style1", 3, "ngClass"], [1, "custom-control", "custom-radio", "text-nowrap", "dropdown-item"], ["ycnDisabled", "", 1, "dropdown-item", 3, "disabled"], ["type", "checkbox", 1, "custom-control-input", 3, "change", "ngModelChange", "disabled", "ngModel"], [1, "custom-control-indicator"], [1, "custom-control-description", 3, "innerHTML"], ["type", "radio", 1, "custom-control-input", 3, "change", "disabled", "name", "value", "checked"], [1, "custom-control-description"], [1, "help-toggler", 3, "click"], ["ycnDisabled", "", 1, "dropdown-item", 3, "click", "disabled"], ["href", "javascript:void(0)", "ycnDisabled", "", 1, "dropdown-item", "custom-control", "custom-checkbox", "custom-checkbox-accented", 3, "click", "disabled"], ["type", "checkbox", 1, "custom-control-input", 3, "checked"]], template: function CascadingDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementContainerStart(0, null, 0);
        i0.ɵɵelementStart(2, "a", 2);
        i0.ɵɵlistener("click", function CascadingDropdownComponent_Template_a_click_2_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.toggleOpen()); });
        i0.ɵɵtemplate(3, CascadingDropdownComponent__svg_svg_3_Template, 1, 1, "svg", 3)(4, CascadingDropdownComponent_span_4_Template, 1, 1, "span", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 5);
        i0.ɵɵtemplate(6, CascadingDropdownComponent_ng_container_6_Template, 2, 1, "ng-container", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementContainerEnd();
        i0.ɵɵelement(7, "ycn-help-modal", null, 1);
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵclassMap(ctx.buttonClass);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c1, ctx.showDropdownCaret))("disabled", ctx.inputDisabled);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.config.title.icon);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.config.title.label);
        i0.ɵɵadvance();
        i0.ɵɵclassMap(i0.ɵɵinterpolate1("dropdown-menu ", ctx.dropdownClass));
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(13, _c2, ctx.isOpen));
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngForOf", ctx.config.list);
    } }, dependencies: [i2.NgClass, i2.NgForOf, i2.NgIf, i2.NgSwitch, i2.NgSwitchCase, i3.DisabledDirective, i4.IconDirective, i5.CheckboxControlValueAccessor, i5.NgControlStatus, i5.NgModel, i6.HelpModalComponent], encapsulation: 2, changeDetection: 0 });
